import React, { useRef } from "react"
import '../stylesheets/index.scss';
import styles from '../stylesheets/Index.module.scss'
import { useScrollSpy } from '../utils/index'
import { graphql } from 'gatsby'

import SEO from '../components/SEO'
import Header from '../components/Header'
import Navbar from '../components/Navbar'
import About from '../components/About'
import Portfolio from '../components/Portfolio'
import Contact from '../components/Contact'
import Footer from '../components/Footer'

const App = (props) => {

  const fluid = props.data.indexImage.childImageSharp.fluid
  
  const sectionRefs = [
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null)
  ];

  const activeSection = useScrollSpy({
    sectionElementRefs: sectionRefs,
    offsetPx: -350,
  });

  return (
    <div className={styles.App}>
      <SEO title="Arne Pedersen"/>
      <Header sectionRefs={sectionRefs} fluid={fluid} />
      <Navbar activeSection={activeSection} />
      <section
        id="about"
        ref={sectionRefs[1]}>
        <About />
      </section>
      <section
        id="portfolio"
        ref={sectionRefs[2]}>
        <Portfolio />
      </section>
      <section
        className={styles.contactSection}
        id="contact"
        ref={sectionRefs[3]}>
        <Contact />
      </section>
      <Footer />
    </div>
  );
}

export default App;

export const pageQuery = graphql`
  query {
    indexImage: file(relativePath: { eq: "hero_1920.jpg"}) {
      childImageSharp {
        fluid(maxWidth: 2880) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`